import { BlocksToastGroup } from 'blocks-nextjs/blocks-web-components/components/toast-group/toast-group';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatToastGroup = createComponent({ react: React, tagName: 'cat-toast-group', elementClass: BlocksToastGroup });
